/**
 * Signals PDF Service that page preparation failed.
 * @param {string} errorMessage - Error message which will be included in status endpoint response.
 */
export function signalPdfError(errorMessage) {
    console.log(`pdf.error ${errorMessage}`);
}
